import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Ein Textzustand, den ein Query-Parameter setzen darf — und danach in Ruhe
 * lässt.
 *
 * Die globale Suche schickt ihren Begriff als `?q=` mit, weil Aufträge,
 * Aufgaben und Dateien keine Detailseite haben; der Treffer landet damit auf
 * seiner Liste, vorgefiltert. Als bloßer Anfangswert von `useState` reichte
 * das nicht: React Router hängt eine Seite nicht neu ein, wenn sich nur der
 * Query-String ändert, also käme ein zweiter Treffer nie an — wer schon auf
 * der Aufgabenseite steht und eine Aufgabe anspringt, sähe nur die URL
 * wechseln.
 *
 * Der Effekt hängt am *Wert* des Parameters, nicht am `URLSearchParams`-
 * Objekt, damit ein unbeteiligtes Rerendern nichts auslöst. Wer danach
 * weitertippt, ändert die URL nicht — und bleibt deshalb unbehelligt.
 */
export function useQuerySeededState(
  parameter: string,
): [string, React.Dispatch<React.SetStateAction<string>>] {
  const [suchparameter] = useSearchParams();
  const ausUrl = suchparameter.get(parameter);

  const [wert, setWert] = useState(ausUrl ?? '');

  useEffect(() => {
    if (ausUrl !== null) setWert(ausUrl);
  }, [ausUrl]);

  return [wert, setWert];
}
